import moment from 'moment-timezone'
import { useMemo, useState } from 'react'
import Calendar from 'react-calendar'

import { ButtonRounded } from '@apps-common/components/elements/button'
import {
  ModalBody,
  ModalCloseButton,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalHeaderContainer
} from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'
import 'react-calendar/dist/Calendar.css'

export const ScheduleCancellationModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: any
}) => {
  const [value, onChange] = useState<Date | null>(new Date())

  const minDate = useMemo(() => moment().toDate(), [])
  const maxDate = useMemo(() => moment().add(3, 'weeks').toDate(), [])

  return (
    <ModalContainer classes='!items-center' innerClasses='rounded-3xl !min-h-0 !h-auto !min-w-[min(90%,0px)] !w-auto'>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle='Update' title='Schedule cancellation' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>

      <ModalBody classes='!pt-[100px]'>
        <Calendar
          minDate={minDate}
          maxDate={maxDate}
          onChange={(date) => {
            if (date) {
              onChange(date as Date)
            }
          }}
          value={value}
        />
      </ModalBody>
      <ModalFooter>
        <div className='w-full flex items-center justify-start gap-2'>
          <ButtonRounded
            type='button'
            text='Confirm'
            loading={false}
            className='action-warning !h-[30px] min-h-0 !min-w-[120px] mt-0 !w-auto'
            callback={() => onDismiss(value?.toISOString(), 'confirm')}
          />
          <ButtonRounded
            type='button'
            text='Back'
            loading={false}
            className='action-success !h-[30px] min-h-0 !min-w-[120px] mt-0 !w-auto'
            callback={() => onDismiss(null, 'cancel')}
          />
        </div>
      </ModalFooter>
    </ModalContainer>
  )
}
